class UsersEmailsListSerializer {
  static deSerialize(data) {
    return {
      emails: data.map((user) => user.email),
    };
  }
}

export { UsersEmailsListSerializer };
